'use client';

import { ContentEditDialogForm } from '@/components/admin/contents/content-dialog-form/content-edit-dialog-form';
import { ContentType } from '@jlg-website/shared/constants';

export function FounderEditDialogForm({ value, onEdit }: { value: string; onEdit: () => void }) {
  return (
    <ContentEditDialogForm
      onEditAction={onEdit}
      contentTypeName={ContentType.Founder}
      contentId={Number(value)}
    />
  );
}

export default FounderEditDialogForm;
